import { QrCodeScanner as ScannerIcon } from '@mui/icons-material';

interface CodeInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  onScan: (event: React.KeyboardEvent) => void;
  isScannerActive: boolean;
  isSearchingShipping: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  disabled: boolean;
}

const CodeInput = ({
  inputValue,
  setInputValue,
  onScan,
  isScannerActive,
  isSearchingShipping,
  inputRef,
  disabled,
}: CodeInputProps) => {
  const isDisabled = disabled || !isScannerActive || isSearchingShipping;

  return (
    <div className='relative text-base'>
      <input
        ref={inputRef}
        type='text'
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        onKeyDown={onScan}
        disabled={isDisabled}
        placeholder={
          disabled
            ? 'Seleccione un checkpoint para escanear'
            : isSearchingShipping
              ? 'Buscando...'
              : isScannerActive
                ? 'Esperando señal del lector...'
                : 'Active el lector'
        }
        className={`w-full py-4 px-6 text-base font-bold rounded-lg transition-all outline-none border-2
          ${isSearchingShipping ? 'bg-gray-50 border-orange-200' : ''}
          ${
            !disabled && isScannerActive
              ? 'bg-orange-50/30 border-orange-100 focus:border-[#ff7500] text-gray-800 caret-transparent'
              : 'bg-gray-50 border-gray-200 text-gray-300'
          }
        `}
        autoComplete='off'
      />

      <div className='absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2'>
        {!disabled && isScannerActive && !isSearchingShipping && (
          <div className='w-2 h-2 rounded-full bg-orange-500' />
        )}
        <ScannerIcon
          className={!disabled && isScannerActive ? 'text-orange-500' : 'text-gray-300'}
        />
      </div>
    </div>
  );
};

export default CodeInput;
